import { useState } from 'react'

const useWeeklyCalendarModals = () => {
  const [modalOpen, setModalOpen] = useState(false)
  const [modalMode, setModalMode] = useState('create')
  const [selectedDate, setSelectedDate] = useState(null)
  const [selectedHour, setSelectedHour] = useState(null)
  const [selectedAvailability, setSelectedAvailability] = useState(null)

  const [proposalModalOpen, setProposalModalOpen] = useState(false)
  const [selectedOpponent, setSelectedOpponent] = useState(null)
  const [proposedTime, setProposedTime] = useState(null)
  const [availabilityStart, setAvailabilityStart] = useState(null)
  const [availabilityEnd, setAvailabilityEnd] = useState(null)
  const [directProposal, setDirectProposal] = useState(false)

  const [opponentListOpen, setOpponentListOpen] = useState(false)
  const [selectedSlotOpponents, setSelectedSlotOpponents] = useState([])
  const [selectedSlotTime, setSelectedSlotTime] = useState(null)

  const [proposalActionModalOpen, setProposalActionModalOpen] = useState(false)
  const [selectedProposal, setSelectedProposal] = useState(null)
  const [selectedProposalOpponent, setSelectedProposalOpponent] = useState(null)
  const [selectedProposalMatch, setSelectedProposalMatch] = useState(null)

  const [matchModalOpen, setMatchModalOpen] = useState(false)
  const [selectedMatch, setSelectedMatch] = useState(null)
  const [selectedMatchOpponent, setSelectedMatchOpponent] = useState(null)

  const openAvailabilityModal = (mode, date, timeSlot, availability) => {
    setModalMode(mode)
    setSelectedDate(date)
    setSelectedHour(timeSlot)
    setSelectedAvailability(availability)
    setModalOpen(true)
  }

  const closeAvailabilityModal = () => {
    setModalOpen(false)
    setModalMode('create')
    setSelectedDate(null)
    setSelectedHour(null)
    setSelectedAvailability(null)
  }

  const openProposalModal = (
    opponent,
    nextProposedTime,
    availStart,
    availEnd,
    isDirectProposal = false,
  ) => {
    setSelectedOpponent(opponent)
    setProposedTime(nextProposedTime)
    setAvailabilityStart(availStart)
    setAvailabilityEnd(availEnd)
    setDirectProposal(isDirectProposal)
    setProposalModalOpen(true)
  }

  const closeProposalModal = () => {
    setProposalModalOpen(false)
    setSelectedOpponent(null)
    setProposedTime(null)
    setAvailabilityStart(null)
    setAvailabilityEnd(null)
    setDirectProposal(false)
  }

  const openOpponentList = (opponents, slotTime) => {
    setSelectedSlotOpponents(opponents)
    setSelectedSlotTime(slotTime)
    setOpponentListOpen(true)
  }

  const closeOpponentList = () => {
    setOpponentListOpen(false)
    setSelectedSlotOpponents([])
    setSelectedSlotTime(null)
  }

  const openProposalActionModal = (proposal, opponent, matchWithOpponent) => {
    setSelectedProposal(proposal)
    setSelectedProposalOpponent(opponent)
    setSelectedProposalMatch(matchWithOpponent || null)
    setProposalActionModalOpen(true)
  }

  const closeProposalActionModal = () => {
    setProposalActionModalOpen(false)
    setSelectedProposal(null)
    setSelectedProposalOpponent(null)
    setSelectedProposalMatch(null)
  }

  const openMatchModal = (match, opponent) => {
    setSelectedMatch(match)
    setSelectedMatchOpponent(opponent)
    setMatchModalOpen(true)
  }

  const closeMatchModal = () => {
    setMatchModalOpen(false)
    setSelectedMatch(null)
    setSelectedMatchOpponent(null)
  }

  return {
    availabilityModal: {
      modalOpen,
      modalMode,
      selectedDate,
      selectedHour,
      selectedAvailability,
      openAvailabilityModal,
      closeAvailabilityModal,
    },
    proposalModal: {
      proposalModalOpen,
      selectedOpponent,
      proposedTime,
      availabilityStart,
      availabilityEnd,
      directProposal,
      openProposalModal,
      closeProposalModal,
    },
    opponentList: {
      opponentListOpen,
      selectedSlotOpponents,
      selectedSlotTime,
      openOpponentList,
      closeOpponentList,
    },
    proposalActionModal: {
      proposalActionModalOpen,
      selectedProposal,
      selectedProposalOpponent,
      selectedProposalMatch,
      openProposalActionModal,
      closeProposalActionModal,
    },
    matchModal: {
      matchModalOpen,
      selectedMatch,
      selectedMatchOpponent,
      openMatchModal,
      closeMatchModal,
    },
  }
}

export default useWeeklyCalendarModals
